/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";

import ActionButtonLayout from "../layout/ActionButtonLayout";
import apiClient from "../../lib/common/apiClient";
import notificationState from "../../states/notificationState";

function EguStockExcelDownloadButton ( props ) {
    const {t} = useTranslation();
    const {id, onSuccess, ...others} = props;
    const setNotification = useSetRecoilState(notificationState);
    
    const url = '/api/EguStockExcelDownload';
    const targetFileName = '기준정보_재고 업로드 양식.xlsx';

    const successNotification = (result) => {
        setNotification({
            severity : "success",
            msg : t("success.fileDownloadSuccess"),
            open : true
        });
    };

    const failureNotification = (reason) => {
        setNotification({
            severity : "error",
            msg : t("error.fileDownloadFailure", {reason: reason.response ? reason.response.data : reason}),
            open : true
        });
    };

    const doHandleFileStream = (result) => {
        const blob = new Blob([result.data]);
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = targetFileName;
        link.click();
        window.URL.revokeObjectURL(link.href);
    };

    const fileDownload = () => {
        apiClient
            .get(url, { responseType: "blob" }) // Note : responseType := "blob" !!
            .then((result) => {
                doHandleFileStream(result);
                successNotification(result);
            })
            .catch((reason) => failureNotification(reason));
    }

    return (
        <>
            <ActionButtonLayout
                id={id + "standard-info-stock-file-dowwnload-button"}
                //startIcon={<ExcelIcon />}
                onClick={fileDownload}
                {...others}
            >
                {t("buttonName.excelFormDownload")}
            </ActionButtonLayout>
        </>
    );
}

export default EguStockExcelDownloadButton;

